import { createSlice } from '@reduxjs/toolkit';
import { AccountsSlice } from './AccountsSlice';
import { openAlert, opentConfirmAlert } from './AlertSlice';
import { changeButton } from './SidebarSelectedDataSlice';
import { BUTTON_SELECTION, OddsFormat, WinRiskType, BETSLIP_TABS, RoundRobinOption, BetType, VirtualSports } from '../common/Foundation';
import { updateConfirmationRemoveState, updateLoadingState, updateBetslipTabState, reloadBalanceAndPendingBets, updateStartCountdownState, updateResetCountdownState } from './BetslipSlice';
import BetslipCommon from '../common/BetslipCommon';
import BetslipHelper from '../components/CompactView/LeftSideBarComponent/BetslipComponent/BetslipHelper';
import { EVENT } from '../events/listEvents';
import Constants from '../common/Constants';
import { fetchTeaserOddsSelection } from './TeaserBetslipSlice';
import VSBetslipHelper from '../components/CompactView/LeftSideBarComponent/BetslipComponent/VSBetslipHelper';
import i18next from 'i18next';

/**
 *  Build state Alert Message
 *  Author: Oliver.Nguyen
 */
const EMPTY_VALUE = ''
const EMPTY_OBJECT = {}
const EMPTY_ARRAY = []

const initialState = {
  oddSelections: EMPTY_ARRAY,
  parlayWagerId: EMPTY_VALUE,
  selectionIds: EMPTY_ARRAY,
  eventIds: EMPTY_ARRAY,
  vsOddsFormat: EMPTY_VALUE,
  totalStake: 0,
  potentialWinnings: 0,
  minMaxBets: EMPTY_OBJECT,
  stakeInputs: EMPTY_OBJECT,
  winRiskOptionPerBet: EMPTY_VALUE,
  stakePerBet: EMPTY_VALUE,
  selectedRROs: [RoundRobinOption.PARLAY],
  parlayStake: EMPTY_VALUE,
  isChangeOddsFormat: false,
  acceptedSingleBets: EMPTY_ARRAY,
  acceptedParlayBets: EMPTY_ARRAY
}
export const VSBetslipSlice = createSlice({
    name: 'VSBetslipSlice',
    initialState: initialState,
    reducers: {
      updateSelectionIdsState: (state, {payload}) => {
        state.selectionIds = payload
      },
      updateOddSelectionsState: (state, {payload}) => {
        state.oddSelections = payload
      },
      updateParlayWagerIdState: (state, {payload}) => {
        state.parlayWagerId = payload
      },
      updateEventIdsState: (state, {payload}) => {
        state.eventIds = payload
      },
      updateVSOddsFormatState: (state, {payload}) => {
        state.vsOddsFormat = payload
      },
      updateMinMaxBetState: (state, {payload}) => {
        state.minMaxBets = payload
      },
      updateStakeInputsState: (state, {payload}) => {
        state.stakeInputs = payload
        BetslipHelper.cacheObjectInLocalStorage(payload, 'vsStakeInputs')
      },
      updateWinRiskOptionPerBetState: (state, {payload}) => {
        state.winRiskOptionPerBet = payload
      },
      updateStakePerBetState: (state, {payload}) => {
        state.stakePerBet = payload
      },
      updateTotalStakeState: (state, {payload}) => {
        state.totalStake = payload
      },
      updatePotentialWinningsState: (state, {payload}) => {
        state.potentialWinnings = payload
      },
     
      updateSelectedRROsState: (state, {payload}) => {
        state.selectedRROs = payload
      },
      updateParlayStakeState: (state, {payload}) => {
        state.parlayStake = payload
      },
      updateChangeOddsFormatState: (state, {payload}) => {
        state.isChangeOddsFormat = payload
      },
      updateAcceptedSingleBetsState: (state, {payload}) => {
        state.acceptedSingleBets = payload
      },
      updateAcceptedParlayBetsState: (state, {payload}) => {
        state.acceptedParlayBets = payload
      },
      removeAllVSBetsState: state => {
        state.oddSelections = EMPTY_ARRAY
        state.selectionIds = EMPTY_ARRAY
        state.eventIds = EMPTY_ARRAY
        state.minMaxBets = EMPTY_OBJECT
        state.stakeInputs = EMPTY_OBJECT
        state.stakePerBet = EMPTY_VALUE
        state.selectedRROs = [RoundRobinOption.PARLAY];
      },
      clearAfterPlaceSingleBetsSuccessfully: (state, {payload}) => {
        state.acceptedSingleBets = payload
        state.acceptedParlayBets = EMPTY_ARRAY
        state.oddSelections = EMPTY_ARRAY
        state.selectionIds = EMPTY_ARRAY
        state.eventIds = EMPTY_ARRAY
        state.minMaxBets = EMPTY_OBJECT;
        state.selectedRROs = [RoundRobinOption.PARLAY];
      },
      clearAfterPlaceParlayBetsSuccessfully: (state, {payload}) => {
        state.acceptedParlayBets = payload
        state.acceptedSingleBets = EMPTY_ARRAY
        state.oddSelections = EMPTY_ARRAY
        state.selectionIds = EMPTY_ARRAY
        state.eventIds = EMPTY_ARRAY
        state.minMaxBets = EMPTY_OBJECT;
        state.selectedRROs = [RoundRobinOption.PARLAY];
      }
    }

  });
  
  export const {
    updateSelectionIdsState,
    updateOddSelectionsState,
    updateParlayWagerIdState,
    updateEventIdsState,
    updateVSOddsFormatState,
    updateMinMaxBetState,
    updateStakeInputsState,
    updateWinRiskOptionPerBetState,
    updateStakePerBetState,
    updateTotalStakeState,
    updatePotentialWinningsState,
    updateSelectedRROsState,
    updateParlayStakeState,
    updateChangeOddsFormatState,
    removeAllVSBetsState,
    updateAcceptedSingleBetsState,
    updateAcceptedParlayBetsState,
    clearAfterPlaceSingleBetsSuccessfully,
    clearAfterPlaceParlayBetsSuccessfully
  } = VSBetslipSlice.actions

  export const validateOddsSelections = (data) => {
    return (dispatch, getState) => {
      dispatch(updateLoadingState(true))
      const { user } = getState().AccountsSlice
      const { selectionIds } = getState().VSBetslipSlice
      if (!user.auth) {
        dispatch(AccountsSlice.actions.updateLoginPopupOpening(true))
        VSBetslipHelper.sendMsgToVs('unLogin');
        return
      }
      if (user.currency === 'MBT') {
        dispatch(openAlert({
          message: 'Currency is not supported now!'
        }))
        return
      }
      if (data.length === 0) {
        dispatch(openAlert({
          message: 'No Events'
        }))
        return
      }
      data.forEach((id, index) => {
        if (selectionIds && selectionIds.indexOf(id) > -1) {
          data.splice(index, 1);
        }
      })

      if (selectionIds && (selectionIds.length + data.length > 10)) {
        dispatch(openAlert({
          message: 'MAX_SELECTION'
        }))
        return
      }
      VSBetslipHelper.sendMsgToVs("oddsSelected", data)
    }
  }

  export const addOddsSelections = (data) => {
    return (dispatch, getState) => {
      dispatch(updateLoadingState(true))
      const { selectedBetslipTab } = getState().BetslipSlice
      if (data && Object.keys(data).length > 0) {
        const {
          acceptedSingleBets,
          acceptedParlayBets
        } = getState().VSBetslipSlice

        let stakeInputs = JSON.parse(JSON.stringify(getState().VSBetslipSlice.stakeInputs))
        const selectedRROs = JSON.parse(JSON.stringify(getState().VSBetslipSlice.selectedRROs))
        let minMaxBets = JSON.parse(JSON.stringify(getState().VSBetslipSlice.minMaxBets))

        if (VSBetslipHelper.isAllVSBetSuccessfully(acceptedSingleBets) || VSBetslipHelper.isAllVSBetSuccessfully(acceptedParlayBets)) {
          selectedRROs.length = 0
          stakeInputs = minMaxBets = {}
          selectedRROs.push(RoundRobinOption.PARLAY)
          dispatch(updateAcceptedSingleBetsState(EMPTY_ARRAY))
          dispatch(updateAcceptedParlayBetsState(EMPTY_ARRAY))
          dispatch(updateSelectedRROsState(selectedRROs))
          dispatch(updateStakeInputsState(stakeInputs))
          dispatch(updateParlayStakeState(EMPTY_VALUE))
          dispatch(updatePlaceVSBetInfo())
        }

        const { vsOddsFormat } = getState().VSBetslipSlice
        const oddSelections = JSON.parse(JSON.stringify(getState().VSBetslipSlice.oddSelections))
        const selectionIds = JSON.parse(JSON.stringify(getState().VSBetslipSlice.selectionIds))
        const eventIds = JSON.parse(JSON.stringify(getState().VSBetslipSlice.eventIds))

        if (oddSelections.length === 0) {
          dispatch(changeButton(BUTTON_SELECTION.BET_SLIP))
          if (selectedBetslipTab === BETSLIP_TABS.TEASERS) {
            dispatch(updateBetslipTabState(BETSLIP_TABS.SINGLE))
          }
        }

        VSBetslipHelper.oddsSelectionInfo(oddSelections, selectionIds, eventIds, data, selectedBetslipTab)
        if (selectedBetslipTab === BETSLIP_TABS.SINGLE) {
          const newMinMaxBets = VSBetslipHelper.initMinMaxBet(minMaxBets, oddSelections, vsOddsFormat)
          dispatch(updateMinMaxBetState(newMinMaxBets))
          dispatch(updateStartCountdownState(true))
          dispatch(updateResetCountdownState(true))
        }

        dispatch(updateOddSelectionsState(oddSelections))
        dispatch(updateSelectionIdsState(selectionIds))
        dispatch(updateEventIdsState(eventIds))
        window.fireEvent(EVENT.SCROLL_TO_BOTTOM_AFTER_ADD_BET)
      }
      dispatch(updateLoadingState(false))
    }
  }

  export const removeSelectionById = (id) => {
    return (dispatch, getState) => {
      dispatch(updateLoadingState(true))
      const { options } = getState().SportsSlice
      const selectionIds = JSON.parse(JSON.stringify(getState().VSBetslipSlice.selectionIds))
      const oddSelections = JSON.parse(JSON.stringify(getState().VSBetslipSlice.oddSelections))
      const eventIds = JSON.parse(JSON.stringify(getState().VSBetslipSlice.eventIds))
      const stakeInputs = JSON.parse(JSON.stringify(getState().VSBetslipSlice.stakeInputs))
      const index = selectionIds.indexOf(id);
      if (oddSelections.length === 1) {
        dispatch(changeButton(BetslipHelper.getButtonSelection(options.isTopLeague, options.favourite)));
      }
      if (index > -1){
        selectionIds.splice(index, 1);
        oddSelections.splice(index, 1);
        eventIds.splice(index, 1)
        // reset invalid bet if there are 1 leg for parlays
        if (oddSelections.length === 1) {
          oddSelections[0].invalidTicket = false
          oddSelections[0].errorCode = oddSelections[0].errorCode === Constants.VS_ERROR.VS_BET_STOPPED_ERROR_CODE ? oddSelections[0].errorCode : ''
        } 
        dispatch(updateOddSelectionsState(oddSelections))
        dispatch(updateSelectionIdsState(selectionIds))
        dispatch(updateEventIdsState(eventIds))
        dispatch(updateStakePerBetState(EMPTY_VALUE))
        dispatch(updateParlayStakeState(EMPTY_VALUE))
        delete stakeInputs[id]
        dispatch(updateStakeInputsState(stakeInputs))
        dispatch(updatePlaceVSBetInfo())
        VSBetslipHelper.sendMsgToVs('removeItem', id);
      }
      dispatch(updateLoadingState(false))
    }
  }

  export const notifyMessage = (data) => {
    return (dispatch, getState) => {
      dispatch(openAlert({
        message: data
      }))
    }
  }

  export const removeAcceptedBetById = (id) => {
    return (dispatch, getState) => {
      const { options } = getState().SportsSlice
      const stakeInputs = JSON.parse(JSON.stringify(getState().VSBetslipSlice.stakeInputs))
      const acceptedSingleBets = JSON.parse(JSON.stringify(getState().VSBetslipSlice.acceptedSingleBets))
      const idx = acceptedSingleBets.findIndex(bet => {
        return bet.selectionId === id
      })
      if (idx > -1) {
        if (acceptedSingleBets.length === 1) {
          dispatch(changeButton(BetslipHelper.getButtonSelection(options.isTopLeague, options.favourite)))
        }
        acceptedSingleBets.splice(idx, 1)
        delete stakeInputs[id]
        dispatch(updateAcceptedSingleBetsState(acceptedSingleBets))
        dispatch(updateStakeInputsState(stakeInputs))
      }
    }
  }

  export const changeVSOddsFormat = (data) => {
    return (dispatch, getState) => {
      const { vsOddsFormat } = getState().VSBetslipSlice
      if (vsOddsFormat !== data) {
        dispatch(updateVSOddsFormatState(data))
        dispatch(updateChangeOddsFormatState(true))
      }
      const { oddSelections } = getState().VSBetslipSlice
      if (oddSelections.length > 0) {
        VSBetslipHelper.sendMsgToVs("refreshOdds", getState().VSBetslipSlice.oddSelections)
      }
    }
  }

  export const refreshOdds = (data) => {
    return (dispatch, getState) => {
      dispatch(updateLoadingState(true))
      if (data && Object.keys(data).length > 0) {
        const { selectedBetslipTab } = getState().BetslipSlice
        const { vsOddsFormat, isChangeOddsFormat } = getState().VSBetslipSlice
        const selectionIds = JSON.parse(JSON.stringify(getState().VSBetslipSlice.selectionIds))
        const oddSelections = JSON.parse(JSON.stringify(getState().VSBetslipSlice.oddSelections))
        const eventIds = JSON.parse(JSON.stringify(getState().VSBetslipSlice.eventIds))
        VSBetslipHelper.refreshOdds(oddSelections, selectionIds, eventIds, getState().VSBetslipSlice.vsOddsFormat, data, selectedBetslipTab)
        if (selectedBetslipTab === BETSLIP_TABS.SINGLE) {
          const { minMaxBets } = getState().VSBetslipSlice
          const newMinMaxBets = VSBetslipHelper.initMinMaxBet(minMaxBets, oddSelections, vsOddsFormat, isChangeOddsFormat)
          dispatch(updateMinMaxBetState(newMinMaxBets))
          if (isChangeOddsFormat) {
            dispatch(updateChangeOddsFormatState(false))
          }
        }
        dispatch(updateOddSelectionsState(oddSelections))
        dispatch(updateSelectionIdsState(selectionIds))
        dispatch(updateEventIdsState(eventIds))
      }
      dispatch(updateLoadingState(false))
    }
  }

  export const changeMinMaxBets = (inputs) => {
    return (dispatch, getState) => {
      let minMaxBets = JSON.parse(JSON.stringify(getState().VSBetslipSlice.minMaxBets))
      if (minMaxBets[inputs.selectionId]) {
        Object.assign(minMaxBets[inputs.selectionId], inputs)
      } else {
        minMaxBets[inputs.selectionId] = inputs
      }
      dispatch(updateMinMaxBetState(minMaxBets))
    }
  }

  export const removeAllVSBets = () => {
    return (dispatch, getState) => {
      const { options } = getState().SportsSlice
      dispatch(removeAllVSBetsState())
      dispatch(updateConfirmationRemoveState(false))
      dispatch(updateStartCountdownState(false))
      VSBetslipHelper.sendMsgToVs('cancelBet');
      dispatch(changeButton(BetslipHelper.getButtonSelection(options.isTopLeague, options.favourite)))
    }
  }

  
export const changeVSStakeInputs = (inputs) => {
  return (dispatch, getState) => {
    let stakeInputs = JSON.parse(JSON.stringify(getState().VSBetslipSlice.stakeInputs))
    if (stakeInputs[inputs.selectionId]) {
      Object.assign(stakeInputs[inputs.selectionId], inputs)
    } else {
      stakeInputs[inputs.selectionId] = inputs
    }
    dispatch(updateStakeInputsState(stakeInputs))
  }
}

export const updateMaxVSBet = (stake, selectionId) => {
  return (dispatch, getState) => {
    const { minMaxBets } = getState().VSBetslipSlice
    const winRiskOption = minMaxBets[selectionId].winRiskOption
    let stakeInputs = JSON.parse(JSON.stringify(getState().VSBetslipSlice.stakeInputs))
    const { vsOddsFormat }  = getState().VSBetslipSlice

    switch (winRiskOption) {
      case WinRiskType.RISK:
        stakeInputs[selectionId].riskVal = BetslipCommon.convertStakeToNumber(stake);
        stakeInputs[selectionId].winVal = BetslipCommon.calculateToWin(stakeInputs[selectionId].riskVal, stakeInputs[selectionId].odds, OddsFormat[vsOddsFormat], winRiskOption, stakeInputs[selectionId].isMoneyLine ? BetType.THE_1X2 : '');
        break;
      case WinRiskType.WIN:
        stakeInputs[selectionId].winVal = BetslipCommon.convertStakeToNumber(stake);
        stakeInputs[selectionId].riskVal = BetslipCommon.calculateToRisk(stakeInputs[selectionId].winVal, stakeInputs[selectionId].odds, OddsFormat[vsOddsFormat], winRiskOption);
        break;
      default: //option = BASE
        if (stakeInputs[selectionId].odds > 0) {
          stakeInputs[selectionId].riskVal = BetslipCommon.convertStakeToNumber(stake);
          stakeInputs[selectionId].winVal = BetslipCommon.calculateToWin(stakeInputs[selectionId].riskVal, stakeInputs[selectionId].odds, OddsFormat[vsOddsFormat], winRiskOption, stakeInputs[selectionId].isMoneyLine ? BetType.THE_1X2 : '');
        } else {
          stakeInputs[selectionId].winVal = BetslipCommon.convertStakeToNumber(stake);
          stakeInputs[selectionId].riskVal = BetslipCommon.calculateToRisk(stakeInputs[selectionId].winVal, stakeInputs[selectionId].odds, OddsFormat[vsOddsFormat], winRiskOption);
        }
    }
    stakeInputs[selectionId].baseVal = parseFloat(stakeInputs[selectionId].odds) > 0 ? stakeInputs[selectionId].riskVal : stakeInputs[selectionId].winVal;
    stakeInputs[selectionId].winRiskOption = winRiskOption
    dispatch(updateStakeInputsState(stakeInputs))
    dispatch(updatePlaceVSBetInfo())
  }
}
export const updateStakeAndWinRiskOptionPerVSBet = (stake, winRiskOption) => {
  return dispatch => {
    dispatch(updateStakePerBetState(stake))
    dispatch(updateWinRiskOptionPerBetState(winRiskOption ? winRiskOption : EMPTY_VALUE))
  }
}

export const updateAllStakeForVSBets = (stake, winRiskOption) => {
  return (dispatch, getState) => {
    const { vsOddsFormat } = getState().VSBetslipSlice
    let stakeInputs = JSON.parse(JSON.stringify(getState().VSBetslipSlice.stakeInputs))
    Object.keys(stakeInputs).forEach(key => {
      const odds = stakeInputs[key].odds;
      let inputs = {}
      if (!winRiskOption) {
        winRiskOption = BetslipHelper.getWinRiskOptionByOdds(stakeInputs[key].odds)
      }
      switch (winRiskOption){
        case WinRiskType.RISK:
          inputs.riskVal = stake;
          inputs.winVal = stake ? BetslipCommon.calculateToWin(inputs.riskVal, odds, OddsFormat[vsOddsFormat], winRiskOption, stakeInputs[key].isMoneyLine ? BetType.THE_1X2 : '') : '';
          break;
        case WinRiskType.WIN:
          inputs.winVal = stake
          inputs.riskVal = stake ? BetslipCommon.calculateToRisk(inputs.winVal, odds, OddsFormat[vsOddsFormat], winRiskOption) : '';
          break;
        default:
          if (odds > 0) {
            inputs.riskVal = stake;
            inputs.winVal = stake ? BetslipCommon.calculateToWin(inputs.riskVal, odds, OddsFormat[vsOddsFormat], winRiskOption, stakeInputs[key].isMoneyLine ? BetType.THE_1X2 : '') : '';
          } else if (odds) {
            inputs.winVal = stake;
            inputs.riskVal = stake ? BetslipCommon.calculateToRisk(inputs.winVal, odds, OddsFormat[vsOddsFormat], winRiskOption) : '';
          }
      }
      inputs.baseVal = inputs.baseVal = parseFloat(odds) > 0 ? inputs.riskVal : inputs.winVal;
      inputs.winRiskOption = winRiskOption;
      
      Object.assign(stakeInputs[key], inputs);
    })
    dispatch(updateStakePerBetState(stake));
    dispatch(updateStakeInputsState(stakeInputs));
  }
}

export const updatePlaceVSBetInfo = () => {
  return (dispatch, getState) => {
    const { stakeInputs } = getState().VSBetslipSlice
    let totalStake = 0;
    let totalPotentialWinnings = 0;
    Object.values(stakeInputs).forEach(input => {
        totalStake += BetslipCommon.convertStakeToNumber(input.riskVal)
        totalPotentialWinnings += BetslipCommon.convertStakeToNumber(input.winVal)
    })
    dispatch(updateTotalStakeState(totalStake))
    dispatch(updatePotentialWinningsState(totalPotentialWinnings))
  }
}

const getStake = (stakeInputs, selectionId) => {
  let stake = 0;
  const {riskVal, winVal, odds, winRiskOption} = stakeInputs[selectionId];
  
  switch (winRiskOption) {
    case WinRiskType.RISK:
      stake = BetslipCommon.convertStakeToNumber(riskVal);
      break;
    case WinRiskType.WIN:
      stake = BetslipCommon.convertStakeToNumber(winVal)
      break;
    default:
      stake = BetslipCommon.convertStakeToNumber(parseFloat(odds) > 0 ? riskVal : winVal)
  }
  return stake
}

export const resetStakeAndWinRiskOptionPerVSBet = () => {
  return (dispatch, getState) => {
    const {
      winRiskOptionPerBet,
      stakePerBet
    } = getState().VSBetslipSlice
    if (winRiskOptionPerBet) {
      dispatch(updateWinRiskOptionPerBetState(EMPTY_VALUE))
    }
    if (stakePerBet) {
      dispatch(updateStakePerBetState(EMPTY_VALUE))
    }
  }
}

export const validateVSSingleBets = () => {
  return (dispatch, getState) => {
    const {
      vsOddsFormat
    } = getState().VSBetslipSlice

    const { user } = getState().AccountsSlice
    const oddSelections = JSON.parse(JSON.stringify(getState().VSBetslipSlice.oddSelections))
    const stakeInputs = JSON.parse(JSON.stringify(getState().VSBetslipSlice.stakeInputs))
    const msg = doValidate(oddSelections, stakeInputs, vsOddsFormat)
    if (msg) {
      if (msg !== Constants.VS_ERROR.VS_BET_STOPPED_ERROR_CODE) {
        dispatch(openAlert({
          message: msg
        }))
        // adjust minbet or maxbet if user inputs wrong value
        dispatch(updateOddSelectionsState(oddSelections))
        dispatch(updateStakeInputsState(stakeInputs))
        dispatch(updatePlaceVSBetInfo())
        dispatch(updateStakePerBetState(EMPTY_VALUE))
      } else {
        // display error message on each bet
        dispatch(updateOddSelectionsState(oddSelections))
      }
      return
    }
    const {
      totalRisk,
      totalWin
    } = BetslipHelper.getSingleWinRiskInfo(stakeInputs)

    dispatch(opentConfirmAlert({
      title: 'Confirm bets',
      message: 'PARLAY_CONFIRM_BET',
      params:[totalRisk.toDollar(2, true), user.currency, totalWin.toDollar(2, true), user.currency],
      fireEventKey: EVENT.ALERT_CONFIRM_PLACEBET_VS_SINGLE
    }))
    
  }
}

const doValidate = (oddSelections, stakeInputs, vsOddsFormat) => {
  let validationMessage = ''
  oddSelections.forEach(selection => {
    if (selection.betStatus !== Constants.VS_ERROR.VS_BET_STOPPED_STATUS) {
      const stakeInput = BetslipCommon.convertStakeToNumber(getStake(stakeInputs, selection.selectionId))
      const minStake = BetslipCommon.getMinWinRiskByOddFormat(OddsFormat[vsOddsFormat], stakeInputs[selection.selectionId].winRiskOption, selection)
      const maxStake = BetslipCommon.getMaxWinRiskByOddFormat(OddsFormat[vsOddsFormat], stakeInputs[selection.selectionId].winRiskOption, selection)
      const input = stakeInputs[selection.selectionId]
      const {winRiskOption, odds, isMoneyLine} = input
      
      if (selection.maxStake === 0) {
        validationMessage = Constants.MAX_ZERO_MESSAGE;
      } else {
        let stake = stakeInput;
        if (!stakeInput || stakeInput < minStake) {
          stake = minStake;
          validationMessage = Constants.INVALID_MIN_STAKE;
        }
        if (stakeInput > maxStake) {
          stake = maxStake;
          validationMessage = Constants.INVALID_MAX_STAKE;
        }
        switch (winRiskOption) {
          case WinRiskType.RISK:
            input.riskVal = stake;
            input.winVal = stake ? BetslipCommon.calculateToWin(stake, odds, OddsFormat[vsOddsFormat], winRiskOption, isMoneyLine ? BetType.THE_1X2 : '') : '';
            break;
          case WinRiskType.WIN:
            input.winVal = stake;
            input.riskVal = stake ? BetslipCommon.calculateToRisk(stake, odds, OddsFormat[vsOddsFormat], winRiskOption) : '';
            break;
          default:
            if (odds > 0) {
              input.riskVal = stake;
              input.winVal = stake ? BetslipCommon.calculateToWin(stake, odds, OddsFormat[vsOddsFormat], winRiskOption, isMoneyLine ? BetType.THE_1X2 : '') : '';
            } else {
              input.winVal = stake;
              input.riskVal = stake ? BetslipCommon.calculateToRisk(stake, odds, OddsFormat[vsOddsFormat], winRiskOption) : '';
            }
        }
        input.baseVal = parseFloat(odds) > 0 ? input.riskVal : input.winVal;
      }
    } else {
      Object.assign(selection, {errorCode: Constants.VS_ERROR.VS_BET_STOPPED_ERROR_CODE})
      validationMessage = Constants.VS_ERROR.VS_BET_STOPPED_ERROR_CODE
    }
  })
 return validationMessage
}

export const executePlaceVSSingleBets = () => {
  return (dispatch, getState) => {
    const {
      totalStake,
      stakeInputs
    } = getState().VSBetslipSlice
    const { user } = getState().AccountsSlice
    dispatch(updateLoadingState(true))
    if( user.betCredit) {
      const balance = user.betCredit.replaceAll(',', '')
      if (parseFloat(balance) >= totalStake) {
        const oddSelections = JSON.parse(JSON.stringify(getState().VSBetslipSlice.oddSelections))
        oddSelections.forEach(selection => {
          Object.assign(selection, {
            stake: getStake(stakeInputs, selection.selectionId),
            winRiskStake: stakeInputs[selection.selectionId].winRiskOption
          })
        })
        VSBetslipHelper.sendMsgToVs('placeBet', oddSelections)
      } else {
        setTimeout(() => {
            dispatch(openAlert({
              message: 'errors:INSUFFICIENT_FUNDS'
            }))
            dispatch(updateLoadingState(false))
          }, 
          500
        )
      }
    } else {
      dispatch(updateLoadingState(false))
    }
  }
}

export const refreshAll = () => {
  return (dispatch, getState) => {
    if (getState().VSBetslipSlice.oddSelections.length > 0) {
      VSBetslipHelper.sendMsgToVs("refreshOdds", getState().VSBetslipSlice.oddSelections)
    }
  }
}

export const placeSingleBetSuccessfully = (data) => {
  return (dispatch, getState) => {
    if (data.status === 'success') {
      let errorVsFilter = false;
      let errorAmount = 0;
      const lstData = data.contentData;
      const listWager = data.listWager ? data.listWager : [];
      const oddSelections = JSON.parse(JSON.stringify(getState().VSBetslipSlice.oddSelections))
      oddSelections.forEach((i, key) => {
        const index = listWager.findIndex((item) => item.selectionId === i.selectionId);
        index >= 0 && (oddSelections[key] = {...oddSelections[key], wagerId: listWager[index].wagerId});
      })
      oddSelections.forEach(sel => {
        Object.assign(sel, {placeBetStatus: Constants.VS_ERROR.VS_PLACE_BET_SUCCESS_STATUS})
      })
      Object.keys(lstData).forEach(id => {
        if(lstData[id].placeBetStatus === "INVALID"
        && lstData[id].errorCode ===  Constants.VS_ERROR.BETTING_BUDGET_EXCEEDED) {
          errorVsFilter = true;
          errorAmount = !isNaN(lstData[id].errorAmount) ? Number(lstData[id].errorAmount)  : 0;
          return;
        }
      });
      if(errorVsFilter) {
        const msg = i18next.t('errors:' + Constants.VS_ERROR.BETTING_BUDGET_EXCEEDED, {0: Number(errorAmount).toFixed(2)});
        dispatch(openAlert({
          message: msg
        }));
        dispatch(updateLoadingState(false))
        return;
      }
      Object.keys(lstData).forEach(id => {
        const filter = oddSelections.filter(sel => {
          return sel.selectionId === id
        })
        if (filter.length > 0) {
          oddSelections.forEach(sel => {
            if(sel.selectionId === id) {
              sel = lstData[id];
              sel.placeBetStatus = ''
            }
          })
        }
      })
      
      dispatch(clearAfterPlaceSingleBetsSuccessfully(oddSelections))
      reloadBalanceAndPendingBets()

  } else {
      if (data.content  === 'CURRENCY_NOT_SUPPORT') {
        dispatch(openAlert({
          message: 'Currency is not supported now!'
        }))
      } else {
        dispatch(openAlert({
          message: "errors:" + data.content
        }))
      }
    }
    dispatch(updateLoadingState(false))
  }
}



export const updateAllMinMaxBet = (event, winRiskOption) => {
  return (dispatch, getState) => {
    let minMaxBets= JSON.parse(JSON.stringify(getState().VSBetslipSlice.minMaxBets))
    Object.keys(minMaxBets).forEach(key => {
      if (!winRiskOption) {
        winRiskOption = BetslipHelper.getWinRiskOptionByOdds(minMaxBets[key].odds)
      }
      minMaxBets[key].winRiskOption = winRiskOption
    })
    dispatch(updateMinMaxBetState(minMaxBets))
  }
}

export const showSelectionError = (data) => {
  return (dispatch) => {
    dispatch(openAlert({
      message: data ? 'errors:'+ data : 'errors:'+Constants.INTERNAL_SERVER_ERROR
    }))
    dispatch(updateLoadingState(false))
  }
}

export const changeVSBetslipTab = (tabId) => {
  return (dispatch, getState) => {
    dispatch(updateLoadingState(true))
    const currentTab = getState().BetslipSlice.selectedBetslipTab
    const {  teaserSelections } = getState().TeaserBetslipSlice
    const { isOpenConfirmationRemove } = getState().BetslipSlice
    const { selectedVirtualSportId } = getState().SidebarSelectedDataSlice
    const { oddSelections } = getState().VSBetslipSlice

    if (currentTab !== tabId) {
      dispatch(updateBetslipTabState(tabId))
      if (tabId === BETSLIP_TABS.SINGLE) {
        VSBetslipHelper.sendMsgToVs('enableOddsFormat')
        VSBetslipHelper.sendMsgToVs('updateParlayState', false)
      } else if (tabId === BETSLIP_TABS.PARLAY) {
        VSBetslipHelper.sendMsgToVs('updateParlayState', true)
        VSBetslipHelper.sendMsgToVs('setDefaultAndRefreshOdds')
        VSBetslipHelper.sendMsgToVs('getParlayBetSetting')
        if (selectedVirtualSportId === VirtualSports.VIRTUAL_DOGS.code && oddSelections.length > 1) {
          VSBetslipHelper.sendMsgToVs("refreshOdds", oddSelections)
        }
      }
      if (tabId === BETSLIP_TABS.TEASERS) {
        if (teaserSelections.length > 0) {
          dispatch(fetchTeaserOddsSelection())
        }
      }
      if (isOpenConfirmationRemove) {
        dispatch(updateConfirmationRemoveState(false))
      }
    }
    dispatch(updateLoadingState(false))
  }
}

export const setParlayBetSetting = (betSetting) => {
  return (dispatch, getState) => {
    const oddSelections = JSON.parse(JSON.stringify(getState().VSBetslipSlice.oddSelections))
    oddSelections.forEach(selection => {
      Object.assign(selection, {
        minBet: betSetting.minBet,
        maxBet: betSetting.maxBet
      })
    })
    dispatch(updateOddSelectionsState(oddSelections))
  }
};

export const changeVSRROs = (event, rro) => {
  return (dispatch, getState) => {
    const selectedRROs = JSON.parse(JSON.stringify(getState().VSBetslipSlice.selectedRROs))
    if (event.target.checked) {
      selectedRROs.push(rro)
    } else {
      const index = selectedRROs.indexOf(rro)
      if (index > -1) {
        selectedRROs.splice(index, 1)
      }
    }
    dispatch(updateSelectedRROsState(selectedRROs))
  }
}

export const executePlaceVSParlayBets = () => {
  return (dispatch, getState) => {
    const {
      parlayStake
    } = getState().VSBetslipSlice
    const { user } = getState().AccountsSlice
    try {
      dispatch(updateLoadingState(true))
      if( user.betCredit) {
        const balance = user.betCredit.replaceAll(',', '')
        const parlayStakeStr = parlayStake.toString()
        if (parseFloat(balance) >= parseFloat(parlayStakeStr.replaceAll(",", ""))) {
          const oddSelections = JSON.parse(JSON.stringify(getState().VSBetslipSlice.oddSelections))
  
          oddSelections.forEach(selection => {
            Object.assign(selection, {
              parlayStake: parlayStakeStr,
              winRiskStake: WinRiskType.BASE
            })
          })
          VSBetslipHelper.sendMsgToVs('parlayPlaceBet', {'data': oddSelections, 'options': getState().VSBetslipSlice.selectedRROs})
        } else {
          setTimeout(() => {
            dispatch(openAlert({
              message: 'errors:INSUFFICIENT_FUNDS'
            }))
            dispatch(updateLoadingState(false))
          }, 500)
          return 
        }
      } else {
        dispatch(updateLoadingState(false))
      }
    } catch (error) {
      dispatch(updateLoadingState(false))
    }
  }
}

export const placeParlayBetSuccessfully = (data) => {
  return (dispatch, getState) => {
    if (data.status === 'success') {
      const lstData = data.contentData
      const wagerId = data.wagerId;
      const oddSelections = JSON.parse(JSON.stringify(getState().VSBetslipSlice.oddSelections))
      
      oddSelections.forEach(sel => {
        Object.assign(sel, {placeBetStatus: Constants.VS_ERROR.VS_PLACE_BET_SUCCESS_STATUS})
      })

      if (lstData) {
        Object.keys(lstData).forEach(id => {
          const filter = oddSelections.filter(sel => {
            return sel.selectionId === id
          })
          if (filter.length > 0) {
            Object.assign(oddSelections[id], lstData[id], {placeBetStatus: ''} )
          }
        })
      }
      dispatch(clearAfterPlaceParlayBetsSuccessfully(oddSelections))
      wagerId && dispatch(updateParlayWagerIdState(wagerId))
      reloadBalanceAndPendingBets()

  } else {
      if (data.content  === 'CURRENCY_NOT_SUPPORT') {
        dispatch(openAlert({
          message: 'Currency is not supported now!'
        }))
        return
      } else {
        const error = data.content === Constants.VS_ERROR.VS_EVENT_DUPLICATED ? Constants.VS_ERROR.VS_PARLAY_INVALID_MESSAGE : data.content
        dispatch(openAlert({
          message: "errors:" + error
        }))
        return
      }
    }
    dispatch(updateLoadingState(false))
  }
}

export const removeSuccessParlayBet = (rro) => {
  return (dispatch, getState) => {
    const selectedRROs = JSON.parse(JSON.stringify(getState().VSBetslipSlice.selectedRROs))
    const { options } = getState().SportsSlice
    const filter = selectedRROs.filter(selectedRRO => {
      return selectedRRO !== rro
    })
    if (filter.length === 0) {
      filter.push(RoundRobinOption.PARLAY)
      dispatch(clearAfterPlaceParlayBetsSuccessfully(EMPTY_ARRAY))
      dispatch(updateParlayStakeState(EMPTY_VALUE))
      dispatch(changeButton(BetslipHelper.getButtonSelection(options.isTopLeague, options.favourite)))
    }
    dispatch(updateSelectedRROsState(filter))
  }
}
  
export const vsBetslipSlice = state => state.VSBetslipSlice
export default VSBetslipSlice.reducer;




// WEBPACK FOOTER //
// ./src/app/slices/VSBetslipSlice.js